var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglestore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 145,
    height: 43,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.371 42.731H5.835A5.36 5.36 0 0 1 .494 37.39V5.341A5.36 5.36 0 0 1 5.835 0h133.536a5.36 5.36 0 0 1 5.341 5.341V37.39a5.36 5.36 0 0 1-5.341 5.341z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.371 0H5.835A5.36 5.36 0 0 0 .494 5.341V37.39a5.36 5.36 0 0 0 5.341 5.341h133.536a5.36 5.36 0 0 0 5.341-5.341V5.341A5.36 5.36 0 0 0 139.371 0zm0 .855c2.474 0 4.487 2.013 4.487 4.487V37.39c0 2.474-2.013 4.487-4.487 4.487H5.835c-2.474 0-4.487-2.013-4.487-4.487V5.341c0-2.474 2.013-4.487 4.487-4.487h133.536z",
    fill: "#a6a6a6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.151 10.943c0 .895-.265 1.608-.796 2.14-.603.632-1.389.949-2.355.949-.925 0-1.712-.321-2.359-.962a3.22 3.22 0 0 1-.971-2.386c0-.949.323-1.744.971-2.386s1.434-.962 2.359-.962c.459 0 .898.09 1.316.269s.752.418 1.002.716l-.563.564c-.424-.507-1.009-.76-1.755-.76-.675 0-1.258.237-1.751.711s-.739 1.091-.739 1.849.246 1.374.739 1.849 1.076.711 1.751.711c.716 0 1.313-.238 1.79-.716.31-.311.489-.743.538-1.298H48v-.77h3.106c.03.167.045.328.045.484z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.15 10.943h-.107c-.001.875-.256 1.554-.765 2.064h-.001v.001c-.584.61-1.334.914-2.278.915-.9-.001-1.654-.308-2.283-.931s-.938-1.386-.94-2.31.312-1.686.94-2.31 1.383-.931 2.283-.932a3.2 3.2 0 0 1 1.274.26c.405.174.724.403.963.687l.082-.069-.076-.076-.563.564.075.075.082-.068c-.444-.532-1.067-.8-1.837-.799a2.54 2.54 0 0 0-1.824.742c-.509.493-.772 1.145-.772 1.925s.257 1.431.772 1.925a2.55 2.55 0 0 0 1.824.742c.739.001 1.37-.25 1.866-.747.331-.332.519-.792.568-1.365l.01-.116h-2.337v-.556h2.999v-.107l-.105.019a2.6 2.6 0 0 1 .043.465h.107.107a2.86 2.86 0 0 0-.046-.503l-.016-.088h-3.302v.877.107h2.435v-.107l-.106-.009c-.047.538-.218.942-.507 1.232-.459.457-1.022.683-1.715.684-.65-.001-1.201-.224-1.676-.681s-.705-1.037-.706-1.772.235-1.317.706-1.772S47.35 8.23 48 8.229c.722.002 1.268.24 1.673.722l.075.089.645-.646.069-.069-.063-.075c-.262-.313-.612-.561-1.042-.746A3.41 3.41 0 0 0 48 7.227a3.33 3.33 0 0 0-2.434.994c-.665.661-1.003 1.488-1.003 2.462s.336 1.802 1.003 2.462a3.33 3.33 0 0 0 2.434.993c.989.001 1.81-.328 2.432-.981l-.077-.074.076.075c.553-.553.828-1.3.827-2.215h-.107zm4.924-2.678h-2.919v2.032h2.632v.77h-2.632V13.1h2.919v.787h-3.742v-6.41h3.742v.787z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.074 8.266v-.107h-3.026v2.246h2.632v.556h-2.632v2.246h2.919v.574h-3.528V7.585h3.528v.681h.107v-.107.107h.107v-.787-.107h-3.955v6.623h3.955v-.894-.107h-2.919v-1.819h2.632v-.877-.107h-2.632V8.373h2.919v-.107h-.107zm3.473 5.622h-.824V8.265h-1.79v-.787h4.405v.787h-1.79v5.622z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.548 13.888v-.107h-.717V8.159h-1.79v-.574h4.191v.574h-1.79v5.729h.107v-.107.107h.107V8.373h1.79v-.894-.107h-4.618v.894.107h1.79v5.622h.931.107v-.107h-.107zm4.977 0v-6.41h.823v6.41h-.823z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.525 13.888h.107V7.585h.61v6.196h-.717v.107h.107-.107v.107h.823.107V7.372h-.93-.107v6.623h.107v-.107zm4.476 0h-.824V8.265h-1.79v-.787h4.405v.787h-1.79v5.622z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.002 13.888v-.107h-.717V8.159h-1.79v-.574h4.191v.574h-1.79v5.729h.107v-.107.107h.107V8.373h1.79v-.894-.107h-4.62v.894.107h1.79v5.622h.931.107v-.107h-.107zm6.036-1.365c.475.48 1.055.72 1.742.72a2.35 2.35 0 0 0 1.741-.72c.475-.48.713-1.094.713-1.84s-.238-1.36-.713-1.84a2.35 2.35 0 0 0-1.741-.72c-.686 0-1.267.24-1.742.72s-.711 1.094-.711 1.84.238 1.36.711 1.84zm4.092.537c-.63.648-1.414.972-2.35.972s-1.721-.324-2.349-.972-.944-1.44-.944-2.376.314-1.729.944-2.377a3.14 3.14 0 0 1 2.349-.972 3.14 3.14 0 0 1 2.346.976c.632.651.949 1.441.949 2.372 0 .937-.316 1.729-.944 2.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.038 12.523l-.076.075a2.46 2.46 0 0 0 1.817.752c.711.001 1.326-.252 1.817-.752s.744-1.147.744-1.915-.248-1.415-.744-1.915a2.46 2.46 0 0 0-1.817-.752 2.46 2.46 0 0 0-1.817.752c-.494.5-.744 1.147-.742 1.915s.248 1.415.742 1.915l.076-.075.076-.075c-.453-.461-.68-1.041-.681-1.765s.227-1.304.681-1.765 1.004-.687 1.665-.689 1.209.227 1.665.689.681 1.041.681 1.765-.227 1.304-.681 1.765-1.004.687-1.665.688-1.208-.227-1.665-.688l-.076.075zm4.092.537l-.076-.074c-.613.628-1.362.938-2.274.939s-1.662-.311-2.273-.939l-.003-.003.003.003c-.611-.63-.913-1.389-.914-2.302a3.16 3.16 0 0 1 .914-2.302c.611-.629 1.361-.938 2.273-.939.906.001 1.654.313 2.27.944s.917 1.391.918 2.298c-.001.913-.304 1.672-.914 2.302l.076.074.077.074a3.39 3.39 0 0 0 .974-2.451c.001-.955-.328-1.778-.979-2.447s-1.466-1.01-2.423-1.009-1.779.336-2.426 1.005h0c-.649.666-.975 1.491-.974 2.451s.326 1.786.974 2.451l.003.003-.003-.003c.647.668 1.465 1.005 2.426 1.004a3.26 3.26 0 0 0 2.427-1.004l-.077-.074zm2.1.828v-6.41h1.002l3.115 4.986h.035l-.035-1.235V7.478h.824v6.41h-.86L82.053 8.66h-.035l.035 1.236v3.992h-.823z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.23 13.888h.107V7.585h.836l3.115 4.986h.095.11l-.038-1.344V7.585h.611v6.196h-.694l-3.259-5.228h-.095-.11l.038 1.344v3.884h-.716v.107h.107-.107v.107h.823.107V9.894l-.035-1.237-.107.003v.107h.035V8.66l-.091.057 3.29 5.278h.919.107V7.372h-.931-.107v3.859l.035 1.237.107-.003v-.107h-.035v.107l.091-.057-3.147-5.036H81.23h-.107v6.623h.107v-.107zm33.502 18.16h1.993V18.694h-1.993v13.355zm17.955-8.544l-2.285 5.79h-.069l-2.371-5.79h-2.148l3.557 8.093-2.028 4.501h2.08l5.48-12.594h-2.216zm-11.305 7.027c-.654 0-1.564-.326-1.564-1.134 0-1.031 1.135-1.426 2.113-1.426.877 0 1.288.189 1.822.447a2.42 2.42 0 0 1-2.371 2.113zm.24-7.32c-1.443 0-2.937.636-3.556 2.045l1.769.739c.378-.739 1.082-.979 1.822-.979 1.03 0 2.078.619 2.096 1.718v.137c-.362-.206-1.134-.515-2.079-.515-1.907 0-3.849 1.048-3.849 3.007 0 1.787 1.564 2.938 3.316 2.938 1.34 0 2.078-.601 2.543-1.306h.069v1.031h1.924v-5.12c0-2.371-1.77-3.694-4.055-3.694zm-12.319 1.918h-2.835v-4.578h2.835c1.49 0 2.336 1.234 2.336 2.289 0 1.035-.846 2.289-2.336 2.289zm-.051-6.436h-4.777v13.355h1.993v-5.06h2.784c2.209 0 4.381-1.6 4.381-4.148s-2.172-4.148-4.381-4.148zm-26.046 11.84c-1.377 0-2.53-1.153-2.53-2.737 0-1.6 1.153-2.771 2.53-2.771 1.36 0 2.427 1.17 2.427 2.771 0 1.584-1.067 2.737-2.427 2.737zm2.289-6.282h-.069c-.447-.533-1.308-1.015-2.392-1.015-2.272 0-4.354 1.996-4.354 4.561 0 2.547 2.082 4.526 4.354 4.526 1.084 0 1.945-.482 2.392-1.032h.069v.654c0 1.739-.929 2.668-2.427 2.668-1.222 0-1.979-.878-2.289-1.618l-1.738.723c.499 1.205 1.824 2.685 4.027 2.685 2.341 0 4.32-1.377 4.32-4.733v-8.158h-1.893v.74zm3.27 7.796h1.996V18.693h-1.996v13.355zm4.939-4.406c-.052-1.756 1.36-2.65 2.375-2.65.792 0 1.463.396 1.686.964l-4.061 1.686zm6.196-1.514c-.378-1.016-1.532-2.891-3.89-2.891-2.341 0-4.285 1.842-4.285 4.544 0 2.547 1.927 4.544 4.509 4.544 2.083 0 3.288-1.274 3.787-2.014l-1.549-1.033c-.516.757-1.222 1.256-2.238 1.256s-1.738-.465-2.203-1.377l6.075-2.513-.206-.516zM51.498 24.63v1.927h4.612c-.138 1.084-.499 1.876-1.05 2.427-.671.671-1.721 1.411-3.562 1.411-2.84 0-5.06-2.289-5.06-5.129s2.22-5.129 5.06-5.129c1.532 0 2.65.603 3.476 1.377l1.36-1.359c-1.153-1.102-2.685-1.945-4.836-1.945-3.89 0-7.16 3.167-7.16 7.057s3.27 7.056 7.16 7.056c2.1 0 3.683-.688 4.922-1.979 1.274-1.274 1.67-3.063 1.67-4.509 0-.448-.034-.86-.103-1.205h-6.488zm11.835 5.903c-1.377 0-2.565-1.136-2.565-2.754 0-1.635 1.188-2.754 2.565-2.754s2.564 1.119 2.564 2.754c0 1.618-1.188 2.754-2.564 2.754zm0-7.297c-2.513 0-4.561 1.91-4.561 4.544 0 2.616 2.048 4.544 4.561 4.544s4.561-1.928 4.561-4.544c0-2.633-2.048-4.544-4.561-4.544zm9.949 7.297c-1.377 0-2.564-1.136-2.564-2.754 0-1.635 1.188-2.754 2.564-2.754s2.564 1.119 2.564 2.754c0 1.618-1.188 2.754-2.564 2.754zm0-7.297c-2.513 0-4.561 1.91-4.561 4.544 0 2.616 2.048 4.544 4.561 4.544s4.561-1.928 4.561-4.544c0-2.633-2.048-4.544-4.561-4.544z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.721 34.602l-.079-.076c-.311-.329-.494-.84-.494-1.501v.156V9.554v.156c0-.716.214-1.256.572-1.579l13.236 13.236-13.235 13.235zm-.574-25.054l.005-.172-.005.172zm.005-.175zm0-.007z",
    fill: "url(#A)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.367 25.937l.101-.057 5.227-2.97c.498-.283.831-.627.996-.99-.165.363-.498.707-.996.991l-5.227 2.97-.101.057zm.001-.156l-4.413-4.413 4.412-4.413 5.327 3.026c.676.384 1.056.88 1.12 1.386-.063.507-.443 1.003-1.12 1.387l-5.326 3.027z",
    fill: "url(#B)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.666 35.105c-.37 0-.692-.12-.944-.347h.001c.252.227.575.348.944.348l.098-.002-.098.002zm0-.156c-.37 0-.692-.12-.944-.347h0l13.235-13.235 4.413 4.413-15.506 8.811c-.429.243-.835.358-1.197.358zm-.948-.194l-.069-.067.069.067z",
    fill: "url(#C)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.956 21.367L11.72 8.131c.252-.227.574-.347.943-.347.362 0 .769.116 1.199.359l15.506 8.81-4.412 4.413zm4.512-4.512L13.862 7.987c-.43-.244-.837-.359-1.199-.359.363 0 .769.115 1.199.359l15.606 8.867z",
    fill: "url(#D)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.763 35.103c.336-.019.708-.135 1.099-.356l15.505-8.81-15.505 8.81c-.391.222-.763.337-1.099.356zm-1.042-.345l-.003-.003zm-.072-.07l-.007-.007h0z",
    fill: "#000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.368 25.937l.101-.057-.101.057z",
    fill: "url(#E)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.666 35.105c-.37 0-.693-.121-.944-.348h0l-.072-.07.073-.086c.252.227.574.348.944.347.361 0 .768-.115 1.197-.358l15.506-8.811.099.099-.101.057-15.505 8.81c-.391.222-.763.337-1.099.356l-.098.002z",
    fill: "url(#F)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.642 34.681c-.311-.329-.494-.84-.494-1.501h0c0 .662.183 1.172.494 1.501h0z",
    fill: "#000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.642 34.682c-.311-.329-.494-.839-.494-1.501v-.156c0 .661.184 1.172.494 1.501l.079.076-.079.08z",
    fill: "url(#G)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.643 34.682l.079-.08h0l-.079.079z",
    fill: "url(#H)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.691 21.919a1.32 1.32 0 0 0 .123-.551c0 .185-.041.37-.123.551z",
    fill: "#000"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.467 25.879l-.099-.099 5.326-3.027c.676-.384 1.056-.88 1.12-1.385 0 .185-.041.371-.123.551-.166.363-.498.707-.996.99l-5.227 2.97z",
    fill: "url(#I)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M35.815 21.367h0c0-.559-.374-1.117-1.12-1.541l-5.227-2.97h0 0l5.227 2.97c.747.424 1.121.983 1.12 1.542z",
    fill: "#404040"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M35.815 21.367c-.063-.506-.443-1.002-1.12-1.386l-5.327-3.026.099-.099h0l5.227 2.97c.746.424 1.119.983 1.12 1.542z",
    fill: "url(#J)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.148 9.549zm.005-.174zm0-.005zm0-.006c.062-1.097.659-1.731 1.503-1.735-.366.002-.685.122-.934.347h0l-.003.003-.076.075c-.28.297-.457.741-.489 1.311z",
    fill: "#404040"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.148 9.71v-.156l.005-.179c.032-.581.209-1.025.49-1.322l.078.078c-.359.323-.572.863-.572 1.579zm.57-1.732l.003-.003z",
    fill: "url(#K)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.369 16.954l-15.506-8.81c-.43-.244-.837-.359-1.199-.359-.369 0-.691.12-.943.347l-.078-.078.076-.075c.252-.227.571-.348.937-.35s.777.116 1.207.359l15.606 8.867h0l-.099.099z",
    fill: "url(#L)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 23.782,
    y1: 9.305,
    x2: 5.854,
    y2: 27.234,
    xlinkHref: "#M"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 36.638,
    y1: 21.367,
    x2: 10.789,
    y2: 21.367,
    xlinkHref: "#M"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 27.017,
    y1: 23.818,
    x2: 2.705,
    y2: 48.131,
    xlinkHref: "#M"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 8.289,
    y1: 0.188,
    x2: 19.146,
    y2: 11.045,
    xlinkHref: "#M"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 36.639,
    y1: 21.367,
    x2: 10.79,
    y2: 21.367,
    xlinkHref: "#M"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ccb300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#cc9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#cc8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc7d00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 27.017,
    y1: 23.818,
    x2: 2.704,
    y2: 48.131,
    xlinkHref: "#M"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cc2e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c0e4e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 23.782,
    y1: 9.305,
    x2: 5.854,
    y2: 27.234,
    xlinkHref: "#M"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008de0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#008de0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00a7e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00b8e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00c4e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c7e0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 27.017,
    y1: 23.82,
    x2: 2.705,
    y2: 48.132,
    xlinkHref: "#M"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e0333c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ab0f56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 36.638,
    y1: 21.367,
    x2: 10.789,
    y2: 21.367,
    xlinkHref: "#M"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e0c500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#e0a600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#e09100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e08900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 36.639,
    y1: 21.368,
    x2: 10.79,
    y2: 21.368,
    xlinkHref: "#M"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffce40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#ffbc40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb540"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 23.782,
    y1: 9.304,
    x2: 5.854,
    y2: 27.233,
    xlinkHref: "#M"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40b8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#40b9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#40ceff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#40ddff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#40e7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40eaff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 8.29,
    y1: 0.189,
    x2: 19.147,
    y2: 11.045,
    xlinkHref: "#M"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65b895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#62bd95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#50db97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#44ed98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40f498"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    gradientUnits: "userSpaceOnUse"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglestore);
export default __webpack_public_path__ + "static/media/googlestore.24c58722ef73644dcd90e24b8dacee3d.svg";
export { ForwardRef as ReactComponent };